import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles((theme) => ({
  pageContent: {
    backgroundColor: "white",
    width: "100%",
    // height: "100%",
    borderRadius: "10px 10px 0px 0px",
    boxSizing: "border-box",
    paddingTop: "10px"
  },
  pickercontainers: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 7
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  mobile: {
    display: "none",
    "@media (max-width: 625px)": {
      display: "block",
      float: "right",
      marginTop: "-90px",
      marginRight: "13px"
    },
    "@media (max-width: 413px)": {
      marginTop: "-162px"
    }
  },
  desktop: {
    display: "block",
    "@media (max-width: 625px)": {
      display: "none"
    }
  },
  intro: {
    textAlign: "left",
    "& h4": {
      fontWeight: "700",
      fontSize: "24px",
      marginBlock: "0px"
    },
    "& p": {
      color: "rgba(102, 113, 133, 1)",
      marginBlock: "0px",
      fontSize: "14px"
    }
  },
  introright: {
    textAlign: "right",
    "& h4": {
      fontWeight: "700",
      fontSize: "24px",
      marginBlock: "0px"
    },
    "& p": {
      color: "rgba(102, 113, 133, 1)",
      marginBlock: "0px",
      fontSize: "14px"
    }
  },
  mail: {
    // paddingLeft: "3%",
    cursor: "pointer",
    gap: "2px",
    color: "#0065FF",
    fontWeight: "500",
    lineHeight: "17.4px"
  },
  bankingformbg: {
    backgroundColor: "white"
  },
  brandingcontainer: {
    backgroundColor: "white",
    height: "calc(100vh - 300px)",
    boxSizing: "border-box",
    padding: "24px 15px",
    [theme.breakpoints.down("lg")]: {
      height: "100%"
    }
  },
  title: {
    color: "#101928",
    fontSize: "16px",
    fontWeight: 500,
    letterSpacing: "-0.5px",
    textAlign: "left",
    marginTop: "0px",
    marginBottom: "4px"
  },
  subtitle: {
    color: "#667185",
    letterSpacing: "-0.4px",
    textAlign: "left",
    fontWeight: 400,
    fontSize: "14px",
    marginTop: "0px"
  },
  imagecontainer: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tinycolor(theme.palette.primary.main)
      .lighten(45)
      .toHexString(),
    fontSize: 32,
    fontWeight: "bold"
  },
  profileform: {
    // width: "70%!important",
    [theme.breakpoints.up("lg")]: {
      width: "70%!important"
    }
  },
  brandflex: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap"
  },
  brandesc: {
    width: 200,
    [theme.breakpoints.down("sm")]: {
      width: "100%!important"
    }
  },
  filepicker: {
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
    position: "absolute",
    left: 0,
    top: 0
  },
  editpencil: {
    fontSize: 20
  },
  selectimage: {
    position: "relative",
    width: 200,
    height: 45,
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 32,
    fontWeight: 600,
    fontSize: 12,
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 5
  },
  palettecontainer: {
    display: "flex",
    gap: 10,
    marginTop: 10
  },
  palettewrapper: {
    width: 55,
    height: 55,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    borderRadius: "50%"
  },
  blueselected: {
    border: "1px solid #0065FF"
  },
  pinkselected: {
    border: "1px solid #B00074"
  },
  greenselected: {
    border: "1px solid #099137"
  },
  yellowselected: {
    border: "1px solid #AD6F07"
  },
  colorpalette: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    border: "2px solid #E4E7EC",
    "&:hover, &:focus": {
      cursor: "pointer"
    }
  },
  paletteblue: {
    backgroundColor: theme.palette.primary.main
  },
  palettepink: {
    backgroundColor: "#B00074"
  },
  palettegreen: {
    backgroundColor: "#099137"
  },
  paletteyellow: {
    backgroundColor: "#AD6F07"
  },
  btnspace: {
    marginTop: 15
  },
  downloadbutton: {
    marginTop: 20,
    textAlign: "center"
  },
  profilecontainer: {
    backgroundColor: "#F5F6F7",
    width: "100%",
    height: 258,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 22
  },
  pickercontainer: {
    position: "absolute",
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "25px",
    height: "25px",
    bottom: 0,
    right: 0,
    color: "white",
    borderRadius: "50%"
  },
  camera: {
    color: "white",
    width: "14px!important"
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center"
  },
  profilepicker: {
    opacity: 0,
    width: 25,
    height: 25,
    cursor: "pointer",
    position: "absolute"
  },
  imageviewer: {
    width: "120px",
    height: "120px",
    backgroundColor: "white",
    borderRadius: "50%",
    position: "relative"
  },
  contentpadding: {
    "@media (max-width: 600px)": {
      marginBottom: "10px"
    }
  },
  keycontents: {
    "& a": {
      color: "#0065FF",
      fontWeight: "800"
    }
  },
  employee: {
    display: "flex",
    gap: "10px",
    alignItems: "center"
  },
  footerbtn: {
    minWidth: "170px",
    marginBlock: "30px",
    maxWidth: "500px",
    margin: "auto",
    "& p": {
      fontSize: "14px",
      fontWeight: "700",
      color: theme.palette.primary.main,
      paddingInline: "24px"
    },
    "@media (max-width: 410px)": {
      width: "100%"
    }
  },
  logoContent: {
    // width: "160px",
    height: "40px"
  },
  previewheader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    "& h4": {
      fontWeight: "700",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "& h5": {
      fontWeight: "800",
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& h3": {
      fontWeight: "800",
      fontSize: "20px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h6": {
      fontWeight: "800",
      fontSize: "14px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "@media (max-width: 410px)": {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  previewsubheader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    marginBottom: "8px",
    "& h5": {
      fontWeight: "800",
      fontSize: "24px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h4": {
      fontWeight: "700",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px"
    }
  },
  additem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    cursor: "pointer",
    "& p": {
      color: theme.palette.primary.main,
      fontWeight: "700",
      fontSize: "14px",
      textDecoration: "underline"
    },
    "& .icon": {
      color: theme.palette.primary.main
    }
  },
  icon: {
    color: theme.palette.primary.main
  },
  enterque: {
    color: "#101928",
    display: "flex",
    justifyContent: "left",
    marginBlock: "5px 0px",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "left"
  },
  invoicemain: {
    maxWidth: "900px",
    margin: "auto",
    marginTop: "30px"
  },
  plsintegrate: {
    marginTop: "20px",
    marginLeft: "10px",
    "& p": {
      color: theme.palette.primary.main
    }
  },
  marginitem: {
    marginInline: "20px"
  },
  paymentsuccess: {
    marginInline: "12px",
    padding: "48px",
    border: "1px solid #F0F2F5",
    borderRadius: "15px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    "& *": {
      marginBottom: "16px"
    },
    "@media (max-width: 430px)": {
      padding: "16px"
    }
  },
  paymentdeclined: {
    marginInline: "12px",
    maxWidth: "500px",
    padding: "48px",
    border: "1px solid rgb(229, 224, 226)",
    borderRadius: "15px",
    boxShadow: "0px 4px 8px rgba(97, 3, 3, 0.1)",
    "& *": {
      marginBottom: "16px"
    },
    "@media (max-width: 430px)": {
      padding: "16px"
    }
  },
  quelabel: {
    textAlign: "left",
    display: "flex",
    color: "#545962",
    fontSize: "14px",
    fontWeight: "700"
  },
  mainbatchbtn: {
    width: "100%",
    backgroundColor: "#ffffffff"
  },
  batchbtn: {
    width: "70%",
    alignItems: "center",
    position: "absolute",
    bottom: "12px",
    "@media (max-width: 930px)": {
      width: "95%"
    }
  },
  textandimg: {
    position: "relative",
    borderRadius: "6px",
    border: "1px solid hsl(0, 0%, 80%)",
    backgroundColor: "white",
    height: "150px",
    "& textarea": {
      width: "100%",
      height: "150px",
      boxSizing: "border-box",
      background: "none",
      border: "0px",
      paddingBlock: "10px",
      paddingLeft: "10px",
      paddingRight: "35px",
      color: "black"
    }
  },
  pickcontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginTop: 7
  },
  account_details: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: 0
  },
  accord_body: {
    borderRadius: "16px",
    padding: "15px 20px",
    border: "1px solid #E4E7EC"
  },
  accord_body_primary: {
    border: `2px solid ${theme.palette.primary.main}`
  },
  span: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#98A2B3"
  },
  Icon: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    color: theme.palette.primary.main,
    fontSize: "16px",
    justifyContent: "flex-start",
    pointer: "cursor"
  },
  bank_currency: {
    margin: 0,
    padding: "2px 8px",
    borderRadius: "50%",
    background: theme.palette.primary.main,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px"
  },
  infocontainer: {
    backgroundColor: tinycolor(theme.palette.primary.main)
      .lighten(55)
      .toHexString(),
    borderRadius: "8px",
    padding: "18px 18px",
    marginTop: "10px",
    fontSize: "14px",
    color: "#111827",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    textAlign: "left"
  },
  infotitle: {
    fontWeight: "600",
    marginTop: 0,
    marginBottom: "8px"
  },
  infotext: {
    margin: 0,
    lineHeight: "1.5"
  },
  invoice: {
    fontWeight: "500"
  },
  infolink: {
    color: "#2563eb",
    cursor: "pointer",
    textDecoration: "none",
    marginLeft: "4px"
  },
  // Offline Payment UI
  bankCard: {
    border: "1px solid #F0F2F5",
    borderRadius: "8px",
    padding: "28px 14px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    alignItems: "center",
    gap: "16px",
    position: "relative",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: tinycolor(theme.palette.primary.main).setAlpha(0.02).toRgbString()
    }
  },
  bankHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  bankCardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1
  },
  bankName: {
    margin: 0,
    fontWeight: 600,
    fontSize: "13px",
    color: "#000"
  },
  primaryBadge: {
    position: "absolute",
    top: "8px",
    right: "8px",
    color: "#fff",
    padding: "2px 8px",
    fontSize: "10px",
    background: theme.palette.primary.main,
    fontWeight: 700,
    borderRadius: "4px",
    textTransform: "uppercase"
  },
  // Discount
  discountRow: {
    backgroundColor: "#f0f9ff",
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    "&:hover": {
      backgroundColor: "#e0f2fe"
    }
  },
  discountLabel: {
    fontWeight: "500",
    color: "#000000ff",
    fontSize: "14px"
  },
  discountValue: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: "14px"
  },
  discountActions: {
    textAlign: "center",
    padding: "8px !important"
  },
  deleteIcon: {
    color: "#890404ff",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.main
    }
  },
  // Applying Discount
  selectedInvoices: {
    marginBottom: "16px",
    padding: "12px",
    backgroundColor: theme.palette.background.default,
    borderRadius: "8px",
    border: `1px solid ${theme.palette.divider}`,
    "& h4": {
      marginBlock: "4px"
    }
  },
  invoiceList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px",
    marginTop: "4px"
  },
  invoiceTag: {
    backgroundColor: tinycolor(theme.palette.primary.main).setAlpha(0.04).toRgbString(),
    color: theme.palette.primary.main,
    padding: "8px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 400
  },
  noSelection: {
    textAlign: "center",
    padding: "16px",
    color: "#460101ff",
    fontStyle: "italic",
    fontWeight: "500",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    border: "1px dashed #f77474ff"
  },
  addItemContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    alignItems: "center"
  },
  paymentMethod: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#333",
    lineHeight: "1.4",
    margin: "8px 0",
    padding: "8px 12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    border: "1px solid #e9ecef"
  },
  // PREVIEW TRANSACTION
  previewGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    marginBlock: "1.3rem"
  },
  previewItem: {
    position: "relative",
    width: "100px",
    height: "100px"
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px"
  },
  removeBtn: {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    background: "#ff4d4d",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.75rem"
  },
  invoiceContainer: {
    padding: "10px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    color: "#222",
    textAlign: "left"
  },

  invoiceHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "10px"
  },

  headerLeft: {
    "& h1": {
      fontSize: "22px",
      fontWeight: 700,
      margin: 0
    },
    "& p": {
      color: "#6c757d",
      fontSize: "20px",
      margin: 0
    }
  },

  headerRight: {
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    gap: "10px"
  },

  statusBadge: {
    padding: "1px 12px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: 400,
    display: "inline-block",
    marginBottom: "5px",
    textTransform: "capitalize"
  },
  invoiceNumber: {
    "& small": {
      display: "block",
      fontSize: "18px",
      color: "#6c757d"
    },
    "& span": {
      fontWeight: 700,
      fontSize: "16px"
    }
  },
  detailItem: {
    "& label": {
      display: "block",
      fontSize: "12px",
      color: "#667185",
      marginBottom: "3px"
    },
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 400
    }
  },

  invoiceParties: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    borderTop: "1px solid #eee",
    marginBottom: "30px",
    "& p": {
      margin: "0 0 4px 0",
      fontSize: "14px"
    }
  },

  invoiceTableSection: {
    marginTop: "10px"
  },

  invoiceTable: {
    width: "100%",
    borderCollapse: "collapse",
    "& th": {
      textAlign: "left",
      fontSize: "13px",
      color: "#6c757d",
      paddingBottom: "10px",
      borderBottom: "1px solid #eee"
    },
    "& td": {
      padding: "12px 0",
      fontSize: "14px",
      borderBottom: "1px solid #f1f1f1"
    }
  },

  summaryContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px"
  },

  summaryWrapper: {
    width: "260px"
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
    color: "#444",
    padding: "5px 0"
  },

  grandTotal: {
    fontWeight: 700,
    borderTop: "1px solid #ddd",
    marginTop: "10px",
    paddingTop: "10px",
    color: "#007bff"
  },

  invoiceFooter: {
    marginTop: "40px",
    textAlign: "right"
  },

  printButton: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "none",
    color: "#007bff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    "& svg": {
      marginRight: "6px",
      fontSize: "18px"
    },
    "&:hover": {
      textDecoration: "underline"
    }
  },
  fordesc: {
    color: "#000",
    fontWeight: "500",
    textAlign: "left",
    marginBlock: "0px 5px"
  },
  schoolInfo: {
    borderTop: "1px solid #2d2d2dff",
    borderBottom: "1px solid #2d2d2dff",
    padding: "8px 0",
    margin: "0px 0px"
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "4px 0"
  },
  label: {
    fontWeight: "500",
    color: "#666",
    fontSize: "14px"
  },
  value: {
    fontWeight: "400",
    color: "#000000ff",
    fontSize: "14px",
    textAlign: "right"
  },
  // History by ID Badge
  statusDescription: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap"
  },
  historyBadge: {
    padding: "8px 14px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "700",
    letterSpacing: "0.1px",
    boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
    border: "1px solid transparent",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    overflow: "hidden",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "12px",
      transform: "translateY(-50%)",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "currentColor",
      boxShadow: "0 0 8px currentColor"
    },
    paddingLeft: "32px",
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
      borderRadius: "10px"
    }
  },
  statusPending: {
    background: "linear-gradient(135deg, #FFF3CD 0%, #FFEAA7 100%)",
    color: "#856404",
    borderColor: "#F39C12",
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 6px 12px rgba(243, 156, 18, 0.25)"
    }
  },
  statusApproved: {
    background: "linear-gradient(135deg, #D1ECF1 0%, #B8DAE4 100%)",
    color: "#0C5460",
    borderColor: "#27AE60",
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 6px 12px rgba(39, 174, 96, 0.25)"
    }
  },
  statusOther: {
    background: "linear-gradient(135deg, #F8D7DA 0%, #F1AEB5 100%)",
    color: "#721C24",
    borderColor: "#E74C3C",
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 6px 12px rgba(231, 76, 60, 0.25)"
    }
  },
  // PAYMENT STATUS BADGE FOR INVOICE DETAILS PAGE
  paymentBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  },
  paid: {
    backgroundColor: "#e7f7ef",
    color: "#0caf60",
    border: "1px solid #0caf60"
  },
  partlyPaid: {
    backgroundColor: "#fff4e6",
    color: "#ff8a00",
    border: "1px solid #ff8a00"
  },
  unpaid: {
    backgroundColor: "#ffe6e6",
    color: "#ff4d4f",
    border: "1px solid #ff4d4f"
  },
  paymentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px"
  },
  overpaid: {
    backgroundColor: "#fef3e2",
    color: "#f59e0b",
    border: "1px solid #fbbf24"
  },
  badgeIcon: {
    marginRight: "6px",
    fontSize: "14px"
  },
  // OFFLINE PAYMENT INSTRUCTIONS STYLES
  copyContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "#f8fafc",
    borderRadius: "6px",
    padding: "4px 8px",
    border: "1px solid #e2e8f0"
  },

  detailValue: {
    fontSize: "14px",
    color: "#1e293b",
    fontWeight: "600",
    fontFamily: "monospace",
    letterSpacing: "0.5px"
  },

  copyIcon: {
    color: "#64748b",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      background: "#e2e8f0",
      color: "#475569"
    },
    "&:active": {
      transform: "scale(0.95)"
    }
  },
  paymentInstructions: {
    background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "14px",
    margin: "16px 0"
  },

  paymentHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px"
  },

  paymentTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#1e293b",
    margin: 0
  },

  paymentSubtitle: {
    fontSize: "14px",
    textAlign: "left",
    color: "#64748b",
    marginBottom: "4px",
    lineHeight: "1.5"
  },

  bankAccountsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "16px",
    marginBottom: "24px"
  },

  bankAccountCard: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "16px",
    transition: "all 0.2s ease-in-out",
    position: "relative",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
      borderColor: "#cbd5e1"
    }
  },

  bankCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "16px"
  },

  bankInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  primaryTag: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
    fontSize: "11px",
    fontWeight: "600",
    padding: "2px 8px",
    borderRadius: "12px",
    marginLeft: "8px"
  },
  currencyBadge: {
    background: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px",
    borderRadius: "6px",
    border: "1px solid #e2e8f0"
  },
  accountDetails: {
    spaceY: "12px"
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "4px",
    "&:last-child": {
      marginBottom: 0
    },
    "@media (max-width: 355px)": {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  detailLabel: {
    fontSize: "13px",
    color: "#64748b",
    fontWeight: "500"
  },
  verifiedBadge: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "#f0fdf4",
    color: "#166534",
    fontSize: "12px",
    fontWeight: "500",
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #bbf7d0",
    marginTop: "12px",
    width: "fit-content"
  },

  paymentNotes: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "16px"
  },

  noteItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "8px",
    textAlign: "left",
    "&:last-child": {
      marginBottom: 0
    },
    fontSize: "13px",
    color: "#475569"
  },
  // Zoom Receit in Payment Hsitory
  receiptImageContainer: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease-in-out",
    cursor: "zoom-in",
    height: "200px",
    "&:hover": {
      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
      "& $receiptImage": {
        transform: "scale(2.5)"
      },
      "& $imageZoomOverlay": {
        opacity: 1
      }
    }
  },

  receiptImage: {
    width: "100px",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease-in-out",
    transformOrigin: "center center"
  },

  imageZoomOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
    pointerEvents: "none"
  },
  invoiceSummary: {
    textAlign: "right",
    fontWeight: "400",
    fontSize: "14px",
    padding: "24px",
    "@media (max-width: 768px)": {
      padding: "12px",
      textAlign: "left"
    }
  },
  summarContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "4px",
    "@media (max-width: 768px)": {
      alignItems: "flex-start"
    }
  },
  grand: {
    fontSize: "18px",
    borderTop: "1px solid #E5E7EB",
    paddingTop: "8px",
    marginTop: "4px",
    "@media (max-width: 500px)": {
      fontSize: "14px"
    }
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "250px",
    "@media (max-width: 500px)": {
      maxWidth: "100%"
    }
  }
}));
